import { faCheck } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const Question = (props) => {
  let language = props.language || {}
  return (
    <div className='col-md-12 px-0 quiz-space-bottom'>
      <div className='row'>
        <div className='col-md-12'>
          {/* <div
            className={`${
              !props.isSubmission ? 'position-absolute right-2' : ''
            }`}
          > */}
          <div className={`${!props.isSubmission ? '' : ''}`}>
            {/* {props.isSubmission && ( */}
            {console.log('patrik17', props.score || 0)}
            <span
              className={`${
                props.score == props.points ? 'text-success' : 'text-red'
              }`}
            >
              <b>{`Points: ${props.score || 0} / ${props.points}`}</b>
              {props.score == props.points && (
                <FontAwesomeIcon className='ml-2' icon={faCheck} />
              )}
            </span>
            {/* )} */}
          </div>
        </div>
      </div>
      <div className='row'>
        <div className='col-md-12'>
          <div className='d-flex justify-content-between align-items-center'>
            <div
              dangerouslySetInnerHTML={{
                __html:
                  (typeof props.name === 'string' && props.name) || props.text,
              }}
              className='question-title'
            />
            {!props.isSubmission && (
              <span className='question-points'>
                {/* <b>
                  {language.courses ? language.courses.points : null}:
                  {' ' + props.points}
                </b> */}
              </span>
            )}
          </div>
        </div>
      </div>
      <div className='quiz-row-wrapper mt-1 pt-3 border-top'>
        {props.children}
      </div>
    </div>
  )
}

export default Question
